<template>

  <h1>Reports</h1>
  <div id="time-filter-wrapper">
    <div class="FRNW" style="justify-content: center;">
      <div class="input-div-wrapper">
        <label for="">Select Time Frame:</label>
        <select 
          v-model="timePeriod"
          @change="genReport"
        >
          <option 
            v-for="option in timeOptions"
            :key="option.text"
            :value="option.numMonths"
          >
            {{ option.text }}
          </option>
        </select>
      </div>

      <div class="input-div-wrapper">
        <label for="">Sub Field:</label>
        <select 
          v-model="subFieldOption"
          @change="subFieldChangeHandler"
        >
          <option 
            v-for="option in subFieldOptions"
            :key="option"
            :value="option"
          >
            {{ option }}
          </option>
        </select>
      </div>

      <div class="input-div-wrapper">
        <input 
          type="checkbox" 
          v-model="condenseChart"
          @change="() => genChart( 'bar-chart' )"
        >
        <label for="">Condense Chart?</label>
      </div>  
    </div>
  </div>


  <div id="canvas-wrapper-bar-chart">
    <!-- <canvas id="myChart"></canvas> -->
  </div>


  <div class="doughnut-wrapper">
    <div class="doughnut-wrapper-header FRNW">
      <h1>Film Chemistry Totals</h1>
      <h1>Format Totals</h1>
    </div>
    <div class="doughnut-wrapper-charts FRNW">
      
      <!-- FILM CHEM DOUGHNUT CHART -->
      <!-- ------------------------ -->
      <div
        id="canvas-wrapper-doughnut-film-chemistry"
        class="chart-wrapper"
      >
        <!-- <canvas id="doughnut-film-chemistry"></canvas> -->
      </div>
      <!-- ------------------------ -->

      <!-- FORMAT DOUGHNUT CHART -->
      <!-- --------------------- -->
      <div
        id="canvas-wrapper-doughnut-format"
        class="chart-wrapper"
      >
        <!-- <canvas id="doughnut-format"></canvas> -->
      </div>
      <!-- --------------------- -->
    </div>
  </div>

</template>


<script>

import ModernButtonVue from './basicComponents/ModernButton.vue';
import { LocalStorageFuncs } from '@/utils';

// this is needed for timescale on the x-axis
import 'chartjs-adapter-moment';
import moment from 'moment/moment';

import { 
  Chart, LineElement, LineController, PointElement, 
  BarElement, CategoryScale, LinearScale, Title, 
  Tooltip, Legend, BarController, TimeScale, 
  ArcElement, DoughnutController
} from 'chart.js';

// Register necessary Chart.js components
Chart.register(
  LineElement, LineController, PointElement, TimeScale,
  BarController, BarElement, CategoryScale, LinearScale, 
  Title, Tooltip, Legend,
  ArcElement, DoughnutController
);



// GLOBALS
// ----------------
const NAME = 'ReportsView';
const API = process.env.VUE_APP_API_URL;
let NOTIFICATION, FLA_AXIOS;
// ----------------


export default {
  name: NAME,
  components: {
    ModernButtonVue,
    // Bar,
  },
  props:{

  },
  data() {
    return {

      userId: null,

      timePeriod: null,
      condenseChart: true,

      timeOptions: [
        { text: '1 month', numMonths: 1 },
        { text: '2 months', numMonths: 2 },
        { text: '3 months', numMonths: 3 },
        { text: '6 months', numMonths: 6 },
        { text: '12 months', numMonths: 12 },
      ],
      subFieldOptions: [
        'None', 
        'Film Chemistry',
        'Format'
      ],
      subFieldOption: 'None',

      chartObj: {},
      chartData: {},
      totalOrderDataSet: [],
      filmChemistryDataSets: [],
      formatDataSets: [],

      filmChemistryDoughnutConfig: {},
      formatDoughnutConfig: {},
    }
  },
  computed: {},
  methods: {
    setTimePeriod() {
      this.timePeriod = this.timeOptions[1].numMonths;
    },

    genReport() {    
      // get timezone to send to BE for data consolidation  
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      const data = {
        timePeriodMonths: this.timePeriod,
        userId: this.userId,
        timezone,
      };

      // hit backend to get orders and generate report
      FLA_AXIOS('post', API + '/api/order/generateOrdersReport', data)
      .then( res => {
        const { 
          chartObj, chartData, 
          totalOrderDataSet, filmChemistryDataSets, formatDataSets,
          filmChemistryDoughnutConfig, formatDoughnutConfig
        } = res.data;       
        
        this.chartObj = chartObj;
        this.chartData = chartData;

        this.totalOrderDataSet = totalOrderDataSet;
        this.filmChemistryDataSets = filmChemistryDataSets;
        this.formatDataSets = formatDataSets;

        this.filmChemistryDoughnutConfig = filmChemistryDoughnutConfig
        this.formatDoughnutConfig = formatDoughnutConfig;

        this.genDoughnut();
        this.subFieldChangeHandler();
      })
      .catch( console.error )

    },

    subFieldChangeHandler() {

      const value = this.subFieldOption;
      const dataSetsArr = [ this.totalOrderDataSet ];

      // add format data sets
      if ( value === 'Format' ) {
        dataSetsArr.push( this.formatDataSets );
      }
      // add film chemistry data sets
      else if ( value === 'Film Chemistry' ) {
        dataSetsArr.push( this.filmChemistryDataSets )
      }

      this.addChartDataSets( dataSetsArr );
    },

    addChartDataSets( dataSetsArr ) {
      this.chartData.datasets = dataSetsArr.flat();
      this.genChart( 'bar-chart');
    },

    addCanvas( canvasId ) {

      this.removeCanvas( canvasId );

      const canvas = document.createElement('canvas');
      canvas.id = canvasId;

      const wrapper = document.getElementById(`canvas-wrapper-${canvasId}`);
      wrapper.appendChild(canvas);


      return canvas;
    },

    removeCanvas( canvasId ) {
      const canvas = document.getElementById( canvasId );
      if ( canvas ) canvas.parentNode.removeChild(canvas);
    },

    genChart( canvasId ) {

      // we have to destroy old charts (remove and add canvas)
      this.addCanvas( canvasId );

      // get chart element
      const ctx = document.getElementById( canvasId );

      // build chart
      const chartData = {
        type: 'bar',
        data: this.chartData,
        options: {
          responsive: true,
          plugins: {
            legend: {
              position: 'top'
            },
            title: {
              display: true,
              text: 'Orders by day'
            }
          },
          scales: {
            x: {
              type: 'time',
              time: {
                unit: 'day'
              },
              title: {
                display: true,
                text: 'Date'
              }
            },
            y: {
              title: {
                display: true,
                text: 'Values'
              }
            }
          }
        }
      };

      // set min and max on scale as needed
      if ( !this.condenseChart ) {
        const xScales = chartData.options.scales.x;
        xScales.min = moment()
          .subtract( this.timePeriod, 'months' )
          .startOf( 'day' );
        xScales.max = moment().endOf( 'day' );
      }

      // gen chart
      new Chart( ctx, chartData);
    },

    genDoughnut() {

      // film chem chart
      // ----------------------------------------
      this.addCanvas( 'doughnut-film-chemistry' );
      const ctx_fc = document.getElementById('doughnut-film-chemistry');
      new Chart( ctx_fc, this.filmChemistryDoughnutConfig);
      // ----------------------------------------

      // format chart
      // ---------------------------------
      this.addCanvas( 'doughnut-format' );
      const ctx_f = document.getElementById( 'doughnut-format' );
      new Chart( ctx_f, this.formatDoughnutConfig);
      // ---------------------------------
    }
  },
  mounted(){
    FLA_AXIOS = window.FLA_Axios;
    NOTIFICATION = window.Notification;

    this.userId = LocalStorageFuncs.fetchUserId();

    this.setTimePeriod();
    this.genReport();
  }
}
</script>


<style>

.input-div-wrapper {
  margin: 0 .5rem;
}

.doughnut-wrapper {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-between;
  width: 100%;
}

.chart-wrapper {
  display: flex;
  flex-direction: column;
  width: 49%;
  /* max-width: 50%; */
}

.doughnut-wrapper-header,
.doughnut-wrapper-charts {
  justify-content: space-between;
}
.doughnut-wrapper-header h1 {
  width: 49%;
 }

</style>